import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import * as wjcCore from '@grapecity/wijmo';
import { WjFlexGridCellTemplate } from '@grapecity/wijmo.angular2.grid';
import { environment } from './environments/environment';

wjcCore.setLicenseKey(environment.wijmoLicenseKey);

// Wijmo was compiled for Angular <16 which used format: { propName: ["publicName", "propName"] }
// Angular 17+ changed to: { propName: [InputFlags, "publicName", "propName"] }
// The mismatch causes Angular 21's runtime to not recognize [cellType] as a directive input,
// falling back to DOM property setting on ng-template which throws NG0303 in dev mode.
(function patchWijmoCellTemplateInputs() {
  const dir = (WjFlexGridCellTemplate as any).ɵdir;
  if (dir?.inputs && 'cellTypeStr' in dir.inputs && !('cellType' in dir.inputs)) {
    dir.inputs['cellType'] = ['cellTypeStr', 0, null]; // [privateName, InputFlags.None, transform]
    delete dir.inputs['cellTypeStr'];
    if (dir.declaredInputs) {
      dir.declaredInputs['cellType'] = 'cellType';
      delete dir.declaredInputs['cellTypeStr'];
    }
  }
})();

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
